import Icon from '@/components/snippets/icon/icon'
import clsx from 'clsx'
import { useSort } from 'libs/searchspring/hooks/useSort'

export function FilterSort({ buttonClass = 'btn btn-secondary btn-inline group-data-visible:btn-primary', id = 'sort' }) {
  const { sorts, activeSort, handleSort, resetSort } = useSort()

  return (
    <x-modal className="relative group data-visible:z-1" data-hide-on-blur data-id={id}>
      <button
        className={buttonClass}
        data-modal-role="toggle"
        aria-label="Toggle Sort"
        type="button"
        data-modal-parent={id}
      >
        <Icon id="sort" className="icon-lg" />
        <span className={'text-sm uppercase hidden md:inline-block pr-3'}>Sort</span>
      </button>
      <div
        className="absolute left-0 z-50 flex mt-1 transition-opacity opacity-0 pointer-events-none top-full bg-neutral-medium h-fit w-fit group-data-visible:pointer-events-auto group-data-visible:opacity-100"
      >
        <div className={'flex flex-col'}>
          <div className="flex items-center">
              <input
                id={'sort__default'}
                type="radio"
                value='default'
                name="sort"
                onClick={() => resetSort()}
                checked={!activeSort}
                className="hidden field-radio"
              />
              <label for={'sort__default'} className={clsx('paragraph-md btn-md btn-inline px-4 w-full btn whitespace-nowrap !no-underline', !activeSort ? 'btn-accent-1' : 'btn-primary-text hover:bg-brand-yellow-dark')}>
                Recommended
              </label>
            </div>
          {sorts?.map((sort) => (
            <div className="flex items-center">
              <input
                id={`sort__${sort.value}`}
                type="radio"
                value={sort.value}
                name="sort"
                onClick={() => handleSort(sort.value)}
                checked={activeSort === sort.value}
                className="hidden field-radio"
              />
              <label for={`sort__${sort.value}`} className={clsx('paragraph-md btn-md btn-inline px-4 w-full btn whitespace-nowrap !no-underline', activeSort === sort.value ? 'btn-accent-1' : 'btn-primary-text hover:bg-brand-yellow-dark')}>
                {sort.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </x-modal>
  )
}
